import Typography from '@components/common/Typography'
import React from 'react'

const CommerceCard = ({icon, title, subtitle}: {icon: React.ReactNode; title: string; subtitle: string}) => {
  return (
    <div className="flex flex-col gap-6">
      <div className="bg-error-stroke text-primary-400 rounded-2xl p-4 flex items-center justify-center w-16 h-16">
        {icon}
      </div>
      <div className="flex flex-col gap-4">
        <Typography size="lg" className='text-on-background '>
          {title}
        </Typography>
        <Typography size="md2">{subtitle}</Typography>
      </div>
    </div>
  )
}

export default CommerceCard
